import { useState } from 'react';
import { Text, View } from 'react-native';
import { Link, useRouter } from 'expo-router';
import { useAuth } from '../../src/context/AuthContext';
import { Button, Caption, ErrorText, FormInput, Label, ScreenContainer } from '../../src/components/ui';
import { colors, fonts } from '../../src/theme';
import { ApiError } from '../../src/api/client';
import * as authApi from '../../src/api/auth';

export default function ForgotPasswordScreen() {
  const { login } = useAuth();
  const router = useRouter();
  const [step, setStep] = useState<'request' | 'reset'>('request');
  const [email, setEmail] = useState('');
  const [code, setCode] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [message, setMessage] = useState<string | null>(null);

  const onRequestCode = async () => {
    setError(null);
    setMessage(null);
    setLoading(true);
    try {
      const res = await authApi.forgotPassword(email.trim().toLowerCase());
      setMessage(
        res && 'devOtpCode' in res && res.devOtpCode
          ? `Mã đặt lại mật khẩu (chế độ thử nghiệm): ${res.devOtpCode}`
          : 'Nếu email này đã đăng ký, mã đặt lại mật khẩu đã được gửi tới hộp thư. Vui lòng kiểm tra email.',
      );
      setStep('reset');
    } catch (e) {
      setError(e instanceof ApiError ? e.message : 'Gửi yêu cầu thất bại, vui lòng thử lại');
    } finally {
      setLoading(false);
    }
  };

  const onResetPassword = async () => {
    setError(null);
    setLoading(true);
    try {
      await authApi.resetPassword(email.trim().toLowerCase(), code.trim(), newPassword);
      await login(email.trim().toLowerCase(), newPassword);
      router.replace('/(app)/(tabs)');
    } catch (e) {
      setError(e instanceof ApiError ? e.message : 'Đặt lại mật khẩu thất bại');
    } finally {
      setLoading(false);
    }
  };

  return (
    <ScreenContainer safeTop safeBottom style={{ justifyContent: 'center' }}>
      <Text
        style={{
          fontSize: 24,
          fontFamily: fonts.bold,
          color: colors.text,
          marginBottom: 8,
          letterSpacing: -0.4,
        }}
      >
        Quên mật khẩu
      </Text>

      {step === 'request' ? (
        <>
          <Caption style={{ marginBottom: 20 }}>
            Nhập email đã đăng ký, Loot sẽ gửi mã để đặt lại mật khẩu.
          </Caption>
          <Label>Email</Label>
          <FormInput
            value={email}
            onChangeText={setEmail}
            autoCapitalize="none"
            keyboardType="email-address"
            placeholder="you@example.com"
          />
          <ErrorText>{error}</ErrorText>
          <View style={{ marginTop: 4 }}>
            <Button title="Gửi mã" onPress={onRequestCode} loading={loading} disabled={!email.trim()} />
          </View>
        </>
      ) : (
        <>
          <Caption style={{ marginBottom: 20 }}>{message}</Caption>
          <Label>Mã xác nhận (6 số)</Label>
          <FormInput value={code} onChangeText={setCode} keyboardType="number-pad" placeholder="123456" />
          <Label>Mật khẩu mới</Label>
          <FormInput
            value={newPassword}
            onChangeText={setNewPassword}
            secureTextEntry
            placeholder="Ít nhất 6 ký tự"
          />
          <ErrorText>{error}</ErrorText>
          <View style={{ marginTop: 4 }}>
            <Button
              title="Đặt lại mật khẩu"
              onPress={onResetPassword}
              loading={loading}
              disabled={code.trim().length < 1 || newPassword.length < 6}
            />
            <Button title="Gửi lại mã" variant="outline" onPress={onRequestCode} loading={loading} />
          </View>
        </>
      )}

      <View style={{ flexDirection: 'row', justifyContent: 'center', marginTop: 22, gap: 4 }}>
        <Link href="/(auth)/login" style={{ color: colors.primary, fontFamily: fonts.semiBold, fontSize: 14 }}>
          Quay lại đăng nhập
        </Link>
      </View>
    </ScreenContainer>
  );
}
